import type { Reducer } from 'redux';

import type { Publishers } from '../types';

import { attachmentActionsReducer } from './attachmentActionsReducer';
import { audienceActionsReducer } from './audienceActionsReducer';
import { closeActionsReducer } from './closeActionsReducer';
import { contentActionsReducer } from './contentActionsReducer';
import { indexedDBActionsReducer } from './indexedDBActionsReducer';
import { moderationActionsReducer } from './moderationActionsReducer';
import { openActionsReducer } from './openActionsReducer';
import type { PublishersAction } from './reducer.types';
import { topicActionsReducer } from './topicActionsReducer';

const initialState: Publishers = {};

const reducer: Reducer<Publishers, PublishersAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'PUBLISHER.REMOVE_ALL':
      return initialState;
    default:
      return [
        openActionsReducer,
        closeActionsReducer,
        contentActionsReducer,
        topicActionsReducer,
        attachmentActionsReducer,
        audienceActionsReducer,
        indexedDBActionsReducer,
        moderationActionsReducer,
      ].reduce((prevState, reducer) => reducer(prevState, action), state);
  }
};

export default reducer;
